import React, {Component} from 'react';
import ComandiServerTableRow from './ComandiServerTableRow'
import TablePager from '../TablePager'
import PropTypes from 'prop-types';
import TableColumnOrdered from '../TableColumnOrdered'

class ComandiServerTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };
        
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }


    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    render() {
        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
                    <table className="ui striped sortable celled  table">
            <thead>
            <tr><th colSpan="9">
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    name="id"
                    orderActive={this.props.tableOrderingField === "id"}
                    orderFields="c.idComandoServer"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >ID</TableColumnOrdered>
                <TableColumnOrdered
                    name="nome"
                    orderActive={this.props.tableOrderingField === "nome"}
                    orderFields="c.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Nome</TableColumnOrdered>
                <TableColumnOrdered
                    name="descrizione"
                    orderActive={this.props.tableOrderingField === "descrizione"}
                    orderFields="c.descrizione"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Descrizione</TableColumnOrdered>
                <th className="no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((item) => (
                <ComandiServerTableRow
                    item={item}
                    key={item.idComandoServer}
                    onExecuteCommand={this.props.onExecuteCommand}
                />
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>
                </div>
            </div>)
    }
}

ComandiServerTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onExecuteCommand: PropTypes.func,
}
export default ComandiServerTable;




/** WEBPACK FOOTER **
 ** ./src/components/configurazione/ComandiServerTable.js
 **/